import React, { useState, useEffect } from 'react';
import md5 from 'js-md5';
import LoginPhone from './loginPhone';
import LoginslideVerify from './loginslideVerify';
import { apiGetPhoneLoginCaptcha, apiClickBing, apiRegisterReport } from '../server';
import Fn from '@/utils/fn';
// import { aliyunSlideProps } from '@/components/Login/typings';
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage';
import {
  LoginProps,
  REPORTED_KEY,
  LOGIN_TRAFFIC_SOURCE_KEY,
  LOGIN_360_PROMOTION_PARAMS_KEY,
  LOGIN_SOURCE_BAIDULK,
  LOGIN_SOURCE_MSCLK,
  LOGIN_SOURCE_YKLK,
  LOGIN_SOURCE_SOUGOULK,
  LOGIN_SOURCE_360LK
} from '../types';
import { lmessage } from '../message';
import { setUserInfo } from '@/store/module/user';
import { connect } from 'react-redux';
import { IStoreState } from '@/store/types';
import { withRouter } from 'react-router-dom';
import { loginCollect } from '@/views/login/collect/loginCollect';
import sdk from '@/utils/Buryingpoint';
import yidunSdk from '@/utils/yiDunProtectorWeb';
import {
  buryOptsForUid,
  callBaiduBusinessUpload,
  isBaiduBusinessUploadAvailable,
  BaiduBusinessIndustrValue
} from '../baiduBusinessReport';
import {
  applyBaidu360RetentionOnLogin,
  getRegisterChannelBuryProps,
  setTrafficSourceFromHisId
} from '../loginRetention';
import { getReportHisIdFromSeo, isTrivialPromoReportHisId, normalizePromoLandingSeoOnLogin } from '../promoLanding';

const INDUSTRY_DISPLAY_AD = 'ocpc_zs_convert' as const;
const INDUSTRY_PC_SEARCH = 'ocpc_ps_convert' as const;
const isSatPczsSourceId = (sourceId: string) => sourceId.startsWith('SATpczs');

/** 与本机存的 login360PromotionParams（JSON）一致，用于 REGISTERED / industr */
type Login360PromotionParams = {
  sourceId?: string;
  jzqs?: string;
  data_industry?: BaiduBusinessIndustrValue;
};

function parseLogin360Promotion(): Login360PromotionParams | null {
  try {
    const raw = getLocalStorage(LOGIN_360_PROMOTION_PARAMS_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as Login360PromotionParams;
    return o && typeof o === 'object' ? o : null;
  } catch {
    return null;
  }
}

function Amend(prop: LoginProps) {
  const [current, setCurrent] = useState<number>(0); // 不同页面
  const [phoneData, setPhoneData] = useState<any>({
    code: '',
    phone: ''
  });
  const [hisId, setHisId] = useState<string>('');
  useEffect(() => {
    const normalizedHisId = normalizePromoLandingSeoOnLogin(getLocalStorage(REPORTED_KEY) || '');
    setHisId(normalizedHisId);
    setTrafficSourceFromHisId(normalizedHisId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  function backChange() {
    // setShowVerify(false);
  }
  const collectMsclk = async (msclkId: string, bindType: string) => {
    const res = await apiClickBing({
      type: 2,
      clickId: msclkId,
      deviceId: '',
      bingType: bindType
    });
    console.log(res, 111);
  };
  const collectYklk = async (id: string) => {
    const res = await apiRegisterReport({
      clickId: id
    });
    console.log(res, 111);
  };
  const reportRegisteredByHisId = (eventParam?: string | null, buryUid?: string | number) => {
    const uidOpts = buryOptsForUid(buryUid);
    const reportHisId = getReportHisIdFromSeo(hisId || getLocalStorage(REPORTED_KEY) || '');
    const trafficSource = getLocalStorage(LOGIN_TRAFFIC_SOURCE_KEY) || '';
    const promo360 = parseLogin360Promotion();

    if (!reportHisId || isTrivialPromoReportHisId(reportHisId)) {
      if (!getLocalStorage(REPORTED_KEY)) {
        setLocalStorage(LOGIN_TRAFFIC_SOURCE_KEY, '');
      }
      return;
    }
    const paramArr = reportHisId.split('#');
    const reportedId = paramArr[paramArr.length - 1] ? paramArr[paramArr.length - 1] : '';
    if (reportedId !== '1') {
      callBaiduBusinessUpload({ newType: 25 }, uidOpts);
      return;
    }
    if (trafficSource === LOGIN_SOURCE_BAIDULK) {
      callBaiduBusinessUpload({ newType: 25 }, uidOpts);
      return;
    }

    const subChannel = paramArr[1] || '';
    if (trafficSource === LOGIN_SOURCE_MSCLK || subChannel === 'msclk') {
      collectMsclk(paramArr[0], paramArr[2]);
      return;
    }
    if (
      trafficSource === LOGIN_SOURCE_YKLK ||
      trafficSource === LOGIN_SOURCE_SOUGOULK ||
      subChannel === 'yklk' ||
      subChannel === 'sougoulk'
    ) {
      collectYklk(paramArr[0]);
      return;
    }

    const fromPromo360 =
      trafficSource === LOGIN_SOURCE_360LK && promo360 && isSatPczsSourceId(String(promo360.sourceId || ''));
    const fromHisId360 = isSatPczsSourceId(paramArr[0] || '');
    if (fromPromo360 || fromHisId360) {
      let hasJzqs: boolean;
      let industr: BaiduBusinessIndustrValue;
      if (fromPromo360 && promo360) {
        hasJzqs = Boolean(promo360.jzqs);
        if (promo360.data_industry === INDUSTRY_DISPLAY_AD || promo360.data_industry === INDUSTRY_PC_SEARCH) {
          industr = promo360.data_industry;
        } else {
          industr = hasJzqs ? INDUSTRY_DISPLAY_AD : INDUSTRY_PC_SEARCH;
        }
      } else {
        hasJzqs = paramArr.length >= 5 && Boolean(paramArr[3]);
        industr = hasJzqs ? INDUSTRY_DISPLAY_AD : INDUSTRY_PC_SEARCH;
      }
      const payload360 = {
        businessInfo: 'REGISTERED',
        businessType: '1',
        industr,
        businessParam: hasJzqs
          ? {
              trans_id: md5(String(Date.now())),
              event_param: eventParam ?? null
            }
          : null
      };
      callBaiduBusinessUpload(payload360, uidOpts);
      return;
    }

    callBaiduBusinessUpload({ businessInfo: 'REGISTERED', businessType: '1', businessParam: null }, uidOpts);
  };
  const slideChange = async (phoneData: any) => {
    let res: any = await apiGetPhoneLoginCaptcha({ ...phoneData, check_account: 1 });
    // let res: any = await apiGetPhoneLoginCaptcha({ ...phoneData, ...params, check_account: 1 });
    if (!res.code) res = res.data;
    if (res.code === 200) {
      loginCollect(3010, 1);
      yidunSdk.yiDunProtector('3');
      if (res.data.userInfo) res.data.userinfo = res.data.userInfo;
      delete res.data.userInfo;
      if (res.data?.userinfo.is_register !== 0) {
        sdk.Burying({
          uid: String(res.data.userinfo.id),
          eventname: 'user_register',
          eventtype: 'track',
          properities: getRegisterChannelBuryProps(hisId)
        });
        if (isBaiduBusinessUploadAvailable()) {
          reportRegisteredByHisId(undefined, res.data.userinfo.id);
        }
      } else {
        sdk.Burying({
          uid: String(res.data.userinfo.id),
          eventname: 'user_login',
          eventtype: 'track'
        });
      }
      applyBaidu360RetentionOnLogin(hisId || getLocalStorage(REPORTED_KEY) || '', res.data.userinfo.id);
      prop.setUserInfo(res.data);
      // TODO 去登录
      Fn.getByRefresh(true);
      setCurrent(0);
      // utils.openMain();
    } else {
      lmessage.error(res.msg);
      setCurrent(0);
    }
  };

  const phoneChange = (value: any) => {
    setPhoneData(value);
    slideChange(value);
    // setCurrent(1);
  };

  return (
    <>
      {(() => {
        switch (current) {
          case 0:
            return <LoginPhone phoneData={phoneData} phoneChange={phoneChange} />;
          case 1:
            return <LoginslideVerify setCurrent={setCurrent} backChange={backChange} slideChange={slideChange} />;
          default:
            return null;
        }
      })()}
    </>
  );
}

export default connect(({ settings }: IStoreState) => ({ settings }), { setUserInfo })(withRouter(Amend));
